import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Crown, Check, Loader2 } from "lucide-react";
import { useOutletContext } from "react-router-dom";
import { FeatureLocked } from "@/components/FeatureLocked";

export default function Beneficios() {
  const { user } = useAuth();
  const [tiers, setTiers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/tiers").then((r) => setTiers(r.data)).finally(() => setLoading(false));
  }, []);

  const ctx = useOutletContext<any>();
  const feat = ctx?.features?.benefits;
  if (feat && !feat.available) return <FeatureLocked title="Niveles y Beneficios" unlockTier={feat.unlock_tier} enabled={feat.enabled} />;

  if (loading)
    return <div className="flex justify-center h-96 items-center"><Loader2 className="w-7 h-7 text-gold animate-spin" /></div>;

  return (
    <div className="space-y-6 animate-fade-in" data-testid="benefits-page">
      <div>
        <h1 className="text-3xl font-serif font-medium">Niveles y Beneficios</h1>
        <p className="text-sm text-slate-500 mt-1">
          Estás en el nivel <span className="text-gold-ink font-semibold">{user?.tier}</span>. Estos son los beneficios de tu nivel.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-6">
        {/* FV-485: solo el nivel vigente del usuario */}
        {tiers.filter((t) => t.name === user?.tier).map((t) => {
          return (
            <div
              key={t.name}
              data-testid={`benefit-tier-${t.name}`}
              className="card-obsidian p-6 relative border-gold/50 gold-glow"
            >
              <span className="absolute top-4 right-4 text-xs px-2.5 py-1 rounded-full gold-gradient-bg text-white font-semibold">
                Tu nivel
              </span>
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center"
                  style={{ background: t.color + "22", border: `1px solid ${t.color}` }}
                >
                  <Crown className="w-5 h-5" style={{ color: t.color }} />
                </div>
                <div>
                  <h3 className="text-xl font-serif font-medium">{t.name}</h3>
                  <p className="text-xs text-slate-500 font-mono">
                    Desde {t.min_points.toLocaleString()} pts
                  </p>
                </div>
              </div>
              {t.tagline && <p className="text-sm text-slate-500 mb-4 italic">{t.tagline}</p>}
              <ul className="space-y-2.5">
                {t.benefits.map((b: string, i: number) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-slate-700">
                    <Check className="w-4 h-4 shrink-0 mt-0.5 text-gold" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}
